var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('page-section-primary', {
    attrs: {
      "titWrapClass": _vm.titWrapClass,
      "titWrapSize": _vm.titWrapSize,
      "titWrapAlign": _vm.titWrapAlign,
      "titClass": _vm.titClass,
      "titSize": _vm.titSize,
      "txtClass": _vm.txtClass,
      "txtSize": _vm.txtSize
    },
    scopedSlots: _vm._u([{
      key: "pageSectionHead",
      fn: function () {
        return [_vm._t("containerImmersive"), _vm._t("pageSectionHead")];
      },
      proxy: true
    }, {
      key: "tit",
      fn: function () {
        return [_vm._t("tit")];
      },
      proxy: true
    }, {
      key: "pageSectionFoot",
      fn: function () {
        return [_vm._t("pageSectionFoot")];
      },
      proxy: true
    }], null, true)
  }, [_vm._t("default")], 2);

}
var staticRenderFns = []

export { render, staticRenderFns }